/** Push device registration for the signed-in owner's phone (RPCs register_device / unregister_device; see migration 9). */
import type { Locale } from '../../domain/types';
import type { AuthAdapter } from '../types';
import type { Rest } from './rest';

export interface DeviceRegistrar {
  register(token: string, platform: 'ios' | 'android'): Promise<boolean>;
  unregister(token: string): Promise<void>;
}
export function createDeviceRegistrar(o: { rest: Rest; auth: AuthAdapter; locale: () => Locale }): DeviceRegistrar {
  return {
    async register(token, platform) {
      const businessId = o.auth.getSession()?.businessId;
      if (!businessId) return false;   // not an owner session (or not linked yet): nothing to notify
      await o.rest.rpc('register_device', { p_business_id: businessId, p_token: token, p_platform: platform, p_locale: o.locale() });
      return true;
    },
    async unregister(token) { await o.rest.rpc('unregister_device', { p_token: token }); },
  };
}
